import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule } from '@angular/forms';
import { CustomSortPanelComponent } from './custom-sort-panel.component';
import { TranslateModule } from '@ngx-translate/core';
import { CustomDropdownModule } from '@src/app/shared/components/dropdown/custom-dropdown.module';

@NgModule({
  declarations: [CustomSortPanelComponent],
  imports: [
    TranslateModule,
    CommonModule,
    ReactiveFormsModule,
    CustomDropdownModule
  ],
  exports: [CustomSortPanelComponent]
})
export class CustomSortPanelModule { }
